import { getReadableRoleName } from '@gr/portal/providers/utility.provider';
import { Auth0Role } from '@gr/shared/models';
import { areRolesEqual } from '@gr/shared/utils';
import { Autocomplete } from '@Wonder-Cave/ui';
import { IDropdownValue } from '../Dropdown';

interface IRoleDropdownProps {
  value: IDropdownValue;
  onChange: (newValue?: IDropdownValue | undefined) => void;
  onBlur?: () => void;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError?: boolean;
  shimmer?: boolean;
  hiddenRoles?: Auth0Role[];
}

const RoleDropdown = ({
  value,
  onChange,
  onBlur,
  disabled,
  errorMessage,
  showError,
  shimmer,
  hiddenRoles
}: IRoleDropdownProps): JSX.Element => {
  const allowedRoles = [
    Auth0Role.P2P_ADMIN,
    Auth0Role.P2P_CLICKER,
    Auth0Role.P2P_CLIENT_MANAGER,
    Auth0Role.P2P_CLIENT_USER,
    Auth0Role.P2P_STAFF_MANAGER,
    Auth0Role.P2P_STAFF_USER,
  ];

  const blockedRoles = hiddenRoles ?? [];

  const roles = allowedRoles.filter(role => !blockedRoles.find(target => areRolesEqual(target, role)))
    .map(role => ({
      label: getReadableRoleName(role),
      value: role,
    })) as IDropdownValue[];

  return (
    <Autocomplete
      label="Role"
      value={roles.find((r) => areRolesEqual(r.value, value?.value))}
      options={roles}
      onChange={onChange}
      onBlur={onBlur}
      showError={showError}
      error={errorMessage}
      disabled={disabled}
      shimmer={shimmer}
    />
  );
};

export default RoleDropdown;
